@if (isLoading) {
    <loading [isLoading]="isLoading" [success]="true"></loading>
} @else {
    @if (authSession) {
        <div class="flex flex-col gap-4 sm:pt-4">
            <div class="font-bold border-slate-300 border-b">
                Subscriptions
            </div>
            <user-subscription-table></user-subscription-table>
            <div class="font-bold border-slate-300 border-b">
                Payment Methods
            </div>
            <user-payment-methods></user-payment-methods>
        </div>
    } @else {
        <unauthorized></unauthorized>
    }
}